"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var paginatorList_1 = require("./paginatorList");
var editablelist_1 = require("./editablelist");
var utils_1 = require("../../utils");
var urls_1 = require("../../urls");
var contexts_1 = require("../../interfaces/contexts");
var referenceDialog_1 = require("../references/referenceDialog");
var ActionTable = (function (_super) {
    __extends(ActionTable, _super);
    function ActionTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickExportToExcel = function (event) {
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                var url = (0, urls_1.resolve)(urls_1.Urls.action_excel, context.project) + window.location.search;
                spinnerStart();
                poll_for_result(url, {}, function () {
                    $('div.load_indicator span#finished').html("0");
                    $('div.load_indicator span#max').html("1");
                }, function (data) {
                }, function () {
                    spinnerStop();
                }, function (errorThrown) {
                    notification(errorThrown, { type: "error" });
                    spinnerStop();
                });
            }
            else {
                throw new Error("Cannot export to Excel in this context");
            }
        };
        _this.refetchTable = function (event) {
            var params = window.location.search;
            if (event) {
                (0, utils_1.preventDefault)(event);
                var url = new URL(event.currentTarget.href);
                var search = new URLSearchParams(url.search);
                params = "?" + search.toString();
            }
            window.history.pushState(null, null, window.location.pathname + params);
            App_1.store.actionlist.fetchData(params);
            App_1.store.actionlist.filter.fetchData();
        };
        _this.ActionClickHandler = function (event, action_id) {
            (0, utils_1.preventDefault)(event);
            show_action(action_id);
        };
        return _this;
    }
    ActionTable.prototype.performBulkUpdate = function (selected, values) {
        values["actions"] = selected;
        return App_1.store.actionlist.updateRows(values);
    };
    ActionTable.prototype.performRowUpdate = function (data) {
        return App_1.store.actionlist.updateRows(data).then(function (response) {
            notification(response.message);
        });
    };
    ActionTable.prototype.getReferenceDialogFormProps = function () {
        var formProps = App_1.store.referenceDialog.getFormProps();
        var self = this;
        return __assign(__assign({}, formProps), { onSave: function () { return formProps.onSave().then(function () { return self.refetchTable(); }); } });
    };
    ActionTable.prototype.render = function () {
        return (React.createElement("div", { className: "ActionTable" },
            React.createElement(editablelist_1.EditableList, { columns: App_1.store.actionlist.data.columns, headers: App_1.store.actionlist.data.headers, rows: App_1.store.actionlist.data.rows, performRowUpdate: this.performRowUpdate, refetchTable: this.refetchTable, rowClickHandler: this.ActionClickHandler, allowBulkEditing: true, performBulkUpdate: this.performBulkUpdate, bulkEditFields: App_1.store.actionlist.data.bulk_edit_fields, headerSortClickHandler: this.refetchTable, bulkMenuState: App_1.store.actionlist.bulkMenu.data, updateBulkMenuState: App_1.store.actionlist.bulkMenu.getFetchDataMethod() }),
            React.createElement("div", { className: "ActionTable__Footer" },
                React.createElement(paginatorList_1.default, { paginator: App_1.store.actionlist.data.paginator, click: this.refetchTable })),
            React.createElement(referenceDialog_1.ReferenceDialog, { reference: App_1.store.referenceDialog.reference, isOpen: App_1.store.referenceDialog.isOpen, isReady: App_1.store.referenceDialog.isReady, onDialogClose: App_1.store.referenceDialog.closeDialog.bind(App_1.store.referenceDialog), formProps: this.getReferenceDialogFormProps.bind(this)() })));
    };
    ActionTable = __decorate([
        mobx_react_1.observer
    ], ActionTable);
    return ActionTable;
}(React.Component));
exports.default = ActionTable;
